const NotFoundApiError = require('@/lib/Api/NotFoundApiError');
const { container } = require('@/container');
const { ModalCancelledError } = require('@/vue/modals/ModalCancelledError');

/**
 * @param {Error} err
 */
const suppressModalCancelledErrorOrReThrow = (err) => {
    if (!(err instanceof ModalCancelledError)) {
        // A ModalCancelledError is fine - that means the user pressed the cancelled button.
        // Re-throw anything else because something went wrong.
        throw err;
    }
};

/**
 * @param {Error} err
 */
const suppressNotFoundApiErrorOrDisplay = (err) => {
    if (!(err instanceof NotFoundApiError)) {
        // A NotFoundApiError is fine - that means the requested entity was not found.
        // Anything else is a different error, and we'll show that to the user.

        // The GeneralResponseInterceptor will already display 500 errors, so don't display if it's a 500.
        if (err.statusCode && err.statusCode === 500) {
            return;
        }

        // Display the error to the user.
        container.toastFactory.errorTop('', err.message);
    }
};

module.exports = {
    suppressModalCancelledErrorOrReThrow,
    suppressNotFoundApiErrorOrDisplay,
};
